// extracted by mini-css-extract-plugin
module.exports = {"loading_container":"Loading_loading_container__2ZJc4","lottie_container":"Loading_lottie_container__2OjMW","loading_text":"Loading_loading_text__MopXD"};